import React from 'react';
import { connect } from 'react-redux';
import { Tooltip } from 'antd';
import styled from 'styled-components';
import { FilterOutlined } from '@ant-design/icons';
import { AppState } from '../../app-state';
import { togglePageFilter } from '../../documents/actions/page-controls.actions';

const FilterIcon = styled.span<{ active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0 6px;
  font-size: 18px;
  color: ${p => (p.active ? '#1890ff' : 'inherit')};

  &:hover {
    color: #1890ff;
  }
`;

type Props = {
  enabled: boolean;
  onToggle: (enabled: boolean) => void;
};

const PageFilterButton = ({ enabled, onToggle }: Props) => (
  <Tooltip title="Toggle page filter">
    <FilterIcon active={enabled} onClick={() => onToggle(!enabled)}>
      <FilterOutlined />
    </FilterIcon>
  </Tooltip>
);

export const ConnectedPageFilterButton = connect(
  (state: AppState) => ({
    enabled: state.pageControls.filterCurrentPage,
  }),
  {
    onToggle: (enabled: boolean) => togglePageFilter(enabled),
  },
)(PageFilterButton);
